import styles from "./AcceptedBiometrics.module.scss";

import successIcon from "../../../assets/icons/success-light-icon.svg";
import FullScreenMobilePage from "../../FullScreenMobilePage/FullScreenMobilePage";

const AcceptedBiometrics = () => {
  const { content } = styles;

  return (
    <FullScreenMobilePage>
      <div className={content}>
        <img src={successIcon} alt="Ícono de éxito" />
        <h1>Activaste el ingreso con factor biométrico</h1>
      </div>
    </FullScreenMobilePage>
  );
};

export default AcceptedBiometrics;
